import {
    SHOW_DIALOGUE_WITH_PROPS,
    HIDE_DIALOGUE_BOX
} from './actionConstants';

const initialState = {
    flag:false,
    title:null,
    component:null
};

export default function dialogueBox(state=initialState, action){
    switch(action.type){
        case SHOW_DIALOGUE_WITH_PROPS:
            return Object.assign (
                {},
                state,
                {
                    ...action.payload,
                    showCloseButton: true,
                }
            );

        case HIDE_DIALOGUE_BOX :
            return initialState;

        default :
            return state;
    }
}